import React from 'react';
import {HierarchicalIconclass} from '../types/HierarchicalIconclass';

interface IconclassItemTemplateProps {
  iconclass: HierarchicalIconclass;
}

const IconclassItemTemplate: React.FC<IconclassItemTemplateProps> = ({iconclass}) => {
  const lastNameComponent = iconclass.fullName[iconclass.fullName.length - 1] || iconclass.name;
  const parentPath = iconclass.fullName.slice(0, -1);

  return (
    <div className="flex flex-col">
      <div className="text-sm">
        <span className="font-bold">{iconclass.code}</span>
        <span className="mx-1">-</span>
        <span>{lastNameComponent}</span>
      </div>
      {parentPath.length > 0 && (
        <div className="text-xs text-gray-500 mt-1">
          {parentPath.join(' › ')}
        </div>
      )}
    </div>
  );
};

export default IconclassItemTemplate;

